module.exports = __webpack_public_path__ + "static/media/BTC.cabb5544.jpeg";